import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiKey, ApiKeyModel, API_KEY_MAX_KEYS_PER_USER} from '../models/api-key.model';
import {EntityApiService} from './entity-api.service';

export interface CreateApiKeyRequest {
  name?: string;
  expires_in_days?: number | null;
}

export interface UpdateApiKeyRequest {
  name?: string;
  force_expire?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ApiKeyService extends EntityApiService<ApiKey, ApiKeyModel, CreateApiKeyRequest> {
  readonly maxKeysPerUser = API_KEY_MAX_KEYS_PER_USER;

  constructor() {
    super(ApiKeyModel, 'keys');
  }

  override create(request: CreateApiKeyRequest): Observable<ApiKeyModel>;
  override create(scope: never, request: never): Observable<ApiKeyModel>;
  override create(request: CreateApiKeyRequest): Observable<ApiKeyModel> {
    return this.mapper.map(this.post<ApiKey>('keys', {api_key: request}));
  }

  updateKey(id: string, request: UpdateApiKeyRequest): Observable<ApiKeyModel> {
    return this.mapper.map(this.put<ApiKey>(`keys/${id}`, {api_key: request}));
  }
}
